import { UserAuth } from "../../../context/AuthContext";
import useRolesManager from "../hooks/useRolesManager";
import CreateRoleForm from "./CreateRoleForm";
import RolesList from "./RolesList";
import UserRoleAssigner from "./UserRoleAssigner";
import LoadingCircle from "../../../components/Global/LoadingCircle";
import strings from "../../../locales/ro.json";

const RolesTab = () => {
  const { user } = UserAuth();

  const {
    roleTypes,
    roles,
    users,
    loading,
    error,
    clearError,
    fetchAll,
    createRole,
    updateRole,
    deleteRole,
    assignRole,
    removeRole,
    authToken,
  } = useRolesManager();

  if (loading && roles.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
        <LoadingCircle />
      </div>
    );
  }

  return (
    <div className="rm-container">
      {error && (
        <div className="rm-error" onClick={clearError} style={{ cursor: 'pointer' }}>
          {error} {strings.admin.roles.tab.clickToDismiss}
        </div>
      )}

      <CreateRoleForm
        roleTypes={roleTypes}
        onSubmit={createRole}
        loading={loading}
      />

      <RolesList
        roles={roles}
        onDelete={deleteRole}
        loading={loading}
      />

      <UserRoleAssigner
        users={users}
        roles={roles}
        onAssign={assignRole}
        onRemove={removeRole}
        loading={loading}
        authToken={authToken}
      />
    </div>
  );
};

export default RolesTab;
